export default __webpack_public_path__ + "static/media/Letters1_09.56ea5d2c.png";